module.exports = __webpack_public_path__ + "img/riley-logo-primary.e3263944.png";